import { PaymentMethodMessagingElement } from "@stripe/react-stripe-js";

type ProductLineKlaranAdvertisementProps = { discountedSubtotal: number };

const ProductLineKlarnaAdvertisement = ({
  discountedSubtotal,
}: ProductLineKlaranAdvertisementProps) => {
  return (
    <PaymentMethodMessagingElement
      options={{
        amount: discountedSubtotal,
        currency: "USD",
        paymentMethodTypes: ["klarna"],
        countryCode: "US",
      }}
    />
  );
};

export default ProductLineKlarnaAdvertisement;
